import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Wraps routes that require completed onboarding. Any authenticated non-admin user
 * whose onboarding_complete !== true is redirected to /onboarding.
 */
export default function RequireOnboarding({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (user.role !== "admin" && !user.onboarding_complete) {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}
